import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LayoutAuth from '../../components/layoutAuth';
import { authService } from '../../services/auth';

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    authService.login(email, password, (res) => {
      localStorage.setItem('accessToken', res.data.access);
      localStorage.setItem('refreshToken', res.data.refresh);
      onLogin();
      navigate('/');
    }, () => setError('Invalid credentials'));
  };

  return (
    <LayoutAuth>
      <h1 className="text-2xl font-semibold mb-6">Sign in</h1>
      <form onSubmit={submit} className="space-y-4">
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full p-3 rounded-lg bg-theme-secondary border border-theme-secondary" required />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full p-3 rounded-lg bg-theme-secondary border border-theme-secondary" required />
        {error && <p className="text-red-400 text-sm">{error}</p>}
        <button type="submit" className="w-full py-3 rounded-lg bg-theme-primary text-theme-button font-medium">Sign in</button>
      </form>
    </LayoutAuth>
  );
}
